import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { SuggestionFormComponent } from '../suggestion-form/suggestion-form.component';
import { Suggestion } from '../../models/suggestion.model';

/**
 * Diálogo rápido para enviar una sugerencia sin salir de la página actual
 * (se abre desde el botón + del sidebar). Solo el formulario, sin la lista.
 */
@Component({
  selector: 'app-suggestion-form-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslatePipe,
    SuggestionFormComponent
  ],
  template: `
    <h2 mat-dialog-title class="dialog-title">
      <mat-icon class="title-icon">lightbulb</mat-icon>
      <span>{{ 'gdp.suggestions.title' | translate }}</span>
      <button mat-icon-button class="close-button" (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <app-suggestion-form (saved)="onSaved($event)"></app-suggestion-form>
    </mat-dialog-content>
  `,
  styles: [`
    .dialog-title {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .title-icon {
      color: var(--brand-cyan, #29abe2);
    }
    .close-button {
      margin-left: auto;
    }
    app-suggestion-form {
      display: block;
      padding-top: 4px;
    }
  `]
})
export class SuggestionFormDialogComponent {
  readonly dialogRef = inject<MatDialogRef<SuggestionFormDialogComponent, Suggestion>>(MatDialogRef);

  /** El formulario ya muestra el snackbar de éxito; aquí solo cerramos. */
  onSaved(suggestion: Suggestion): void {
    this.dialogRef.close(suggestion);
  }
}
